export const PLANS = {
    SILVER: 'silver',
    GOLD: 'gold',
    PLATINUM: 'platinum',
};

export const PLAN_PRICES = {
    [PLANS.SILVER]: 799,
    [PLANS.GOLD]: 1499,
    [PLANS.PLATINUM]: 2299,
};

// Align with server ORDER_LIMITS (null = unlimited)
export const ORDER_LIMITS = {
    [PLANS.SILVER]: 50,
    [PLANS.GOLD]: 200,
    [PLANS.PLATINUM]: null,
};

export const PLAN_RANK = {
    [PLANS.SILVER]: 1,
    [PLANS.GOLD]: 2,
    [PLANS.PLATINUM]: 3,
};

export const PLAN_CATALOG = [
    {
        id: PLANS.SILVER,
        name: 'Silver',
        price: PLAN_PRICES[PLANS.SILVER],
        description: 'Perfect for small restaurants getting started',
        orderLimitPerHour: 50,
        features: [
            'Restaurant Management',
            'Order Management (up to 50 orders/hour)',
            'Dishes Management',
            'Default dish categories',
            'Expenses Management',
            'Staff Management',
            'Kitchen Management (Chef queue)',
            'GST calculation, invoices & reports',
            'Basic support',
            'Limited features',
        ],
        limitations: [
            'No analytics on restaurant cards',
            'No detailed analytics',
            'No real-time updates',
            'No QR ordering',
            'No custom dish categories (create & edit)',
        ],
        color: 'slate',
        popular: false,
    },
    {
        id: PLANS.GOLD,
        name: 'Gold',
        price: PLAN_PRICES[PLANS.GOLD],
        description: 'Ideal for growing restaurants',
        orderLimitPerHour: 200,
        features: [
            'Everything in Silver',
            'Order Management (up to 200 orders/hour)',
            'Custom dish categories (create, edit & delete)',
            'Detailed Analytics & Reports',
            'Performance Metrics',
            'Revenue Insights',
            'Priority support',
            'Higher limits on management',
        ],
        limitations: [
            'No real-time updates',
            'No QR ordering',
        ],
        color: 'amber',
        popular: true,
    },
    {
        id: PLANS.PLATINUM,
        name: 'Platinum',
        price: PLAN_PRICES[PLANS.PLATINUM],
        description: 'Complete solution for established restaurants',
        orderLimitPerHour: 'Unlimited',
        features: [
            'Everything in Gold',
            'Order Management (Unlimited orders/hour)',
            'Real-time Updates (WebSocket)',
            'Unlimited Management Features',
            'QR Ordering & Table Management',
            'Dish & restaurant photos (CDN)',
            'QR Code Generation',
            'Customer Ordering System',
            '24/7 Premium Support',
            'All features unlocked',
        ],
        limitations: [],
        color: 'purple',
        popular: false,
    },
];
